import { useTranslation } from "react-i18next";
import { Button, Flex, LoadingOverlay, Paper, Table, Text, Title, useMantineColorScheme } from "@mantine/core";
import { Client } from "src/graphql/generated/graphql";
import { checkClientLocale } from "src/utils/helpers";

import { useClientUsers } from "../../../../hooks/clients";
import { InviteClientUserModal } from "../../../../modals/InviteClientUser";

export interface ClientUsersProps {
    client: Client;
}

export const ClientUsers = ({ client }: ClientUsersProps) => {
    const { t } = useTranslation(["common"]);

    const { colorScheme } = useMantineColorScheme();

    const { clientUsers, isLoadingClientUsers, reloadClientUsers } = useClientUsers(client?.id);

    return (
        <Paper pos="relative" p={36} radius={12}>
            <LoadingOverlay visible={isLoadingClientUsers} />
            <Flex justify="space-between" mb={28}>
                <Title order={3} size={16} weight={600}>
                    {t("client_users")}
                </Title>
                <Button variant="subtle" onClick={() => InviteClientUserModal.display({ onSave: reloadClientUsers })}>
                    {t("client_users_invite")}
                </Button>
            </Flex>
            <Table verticalSpacing={20} horizontalSpacing={0}>
                <thead>
                    <tr>
                        <th>
                            <Text size={14} weight={600} color={colorScheme === "dark" ? "gray.3" : "dark"}>
                                {t("fullname")}
                            </Text>
                        </th>
                        <th>
                            <Text size={14} weight={600} color={colorScheme === "dark" ? "gray.3" : "dark"}>
                                {t("clientuser_role")}
                            </Text>
                        </th>
                        <th>
                            <Text size={14} weight={600} color={colorScheme === "dark" ? "gray.3" : "dark"}>
                                {t("email")}
                            </Text>
                        </th>
                        <th>
                            <Text size={14} weight={600} color={colorScheme === "dark" ? "gray.3" : "dark"}>
                                {t("lang")}
                            </Text>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {(clientUsers || []).map((clientUser, index) => (
                        <tr key={`${index}${clientUser?.id}`}>
                            <td>
                                {clientUser?.firstName} {clientUser?.lastName}
                            </td>
                            <td>{t(`clientuser_role_${clientUser?.role}`)}</td>
                            <td>{clientUser?.email}</td>
                            <td>
                                {clientUser?.locale && checkClientLocale(clientUser?.locale)
                                    ? t(`clientuser_lang_${clientUser.locale}`)
                                    : "-"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Paper>
    );
};
